import { RangeSelecao } from "./RangeSelecao";
import { EntitiesHelper } from "../helpers/entities.helper";
import { BaseObj } from "./UserdataSync";
import { EnumTipoSelecao } from "../enums/EnumTipoSelecao";
import { ProvaDados } from "./ProvaDados";

export class Marcacao extends BaseObj {
  id: string;
  tipoSelecao: EnumTipoSelecao;
  dados: ProvaDados;
  cont: number;
  range: RangeSelecao;
  idLei: string;
  instituicao: any;
  banca: any;
  ano: any;
  tipo: any;
  cargo: any;

  constructor() {
    super();
    // azure card 358 Desativar botão caiu em prova
    this.id = EntitiesHelper.generateGuid();
    this.range = new RangeSelecao();
    this.dados = new ProvaDados();
  }

  public static estaNaLinha(m: Marcacao, id: string, versao: number): boolean {
    return (
      m.range.idItens.findIndex(
        (i) => i.idItem === id && i.idImportacao === versao
      ) !== -1
    );
    // console.log(id, versao);
    // return false;
  }
}
